import React, {useState} from 'react';
import 'quill/dist/quill.snow.css';
import { formatPrice } from '../utils/format';

function ProductCard({idProduct, name, description, price, image, especificacion, onAgregar }) {
  const URL_IMAGE = process.env.REACT_APP_API_URL;
  const [cantidad, setCantidad] = useState(1);
  const [showModal, setShowModal] = useState(false);


  const [quantity, setQuantity] = useState(1);
  
  const handleClick = () => {
    onAgregar(idProduct, cantidad);
  };

  const handleAddToCart = () => {
    // Aquí puedes integrar la lógica para agregar al carrito
    console.log(`Agregado al carrito: ${name} x${quantity}`);
  };

  return (
    <div className="product-card">
      <img
        src={`${URL_IMAGE}`+image}
        alt={name}
        style={{ width: "200px", height: "200px", objectFit: "cover" }}
        onClick={() => setShowModal(true)}

      />

      <h4>{name}</h4>
      <p>{especificacion}</p>
      <p className="price">${formatPrice(price)} <small style={{ color: '#555', fontWeight: 'normal', fontSize: '0.8em' }}>+ IVA</small></p>
      <div className="quantity-selector">
        <label>Cantidad:</label>
        <input
          type="number"
          placeholder="Cantidad"
          value={cantidad}
          //onChange={(e) => setItemVenta({ ...itemVenta, productoId: idProduct, cantidad: e.target.value }) }
          onChange={(e) => setCantidad(e.target.value)}

 
        />
      </div>

      {/*<button onClick={handleAddToCart}>Agregar al carrito</button>*/}
      <button onClick={handleClick}>Agregar al carrito</button>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={() => setShowModal(false)}>×</span>
            <h3>{name}</h3>
            
            <div
              className="ql-editor"
              style={{ padding: 0 }}
              dangerouslySetInnerHTML={{ __html: description }}
            />
            
          </div>
        </div>
      )}

    </div>
  );
}

export default ProductCard;